<template>
  <div class="form-group row">
    <label class="col-4 col-form-label">Пользователи</label>
    <div class="col-8">
      <multiselect
        :options="users"
        :searchable="true"
        :multiple="true"
        :close-on-select="true"
        :show-labels="false"
        v-model="selectedUsers"
        :placeholder="placeholder"
        track-by="id"
        label="fullname"
        @input="changeUsers"
        @open="loadUsers"
        :loading="loading">
        <span slot="noResult">Пользователь не найден.</span>
      </multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import getUsersForMultiselect from './../../../gql/queries/getUsersForMultiselect.graphql'

export default {
  name: 'TcSelectUsers',
  components: {Multiselect},
  props: {
    value: {
      type: Array,
      default: () => []
    },
    usersObjects: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    placeholder () {
      if (this.loading) {
        return 'Загрузка пользователей...'
      } else if (this.selectedUsers.length > 0) {
        return 'Добавить пользователя'
      } else {
        return 'Пользователи не заданы'
      }
    }
  },
  data () {
    return {
      users: [],
      selectedUsers: this.usersObjects,
      loading: false
    }
  },
  methods: {
    loadUsers () {
      this.loading = true
      this.$apollo.query({
        query: getUsersForMultiselect
      }).then(result => {
        this.users = result.data.users
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    changeUsers () {
      let usersIds = this.selectedUsers.map(user => {
        return user.id
      })
      this.$emit('input', usersIds)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TcSelectUsers.vue?04a6d728